import blog1 from "../assets/images/blog-1.jpg";
import blog2 from "../assets/images/blog-2.jpg";
import blog3 from "../assets/images/blog-3.jpg";
import blog4 from "../assets/images/blog-4.jpg";
import blog5 from "../assets/images/blog-5.jpg";
import blog6 from "../assets/images/blog-6.jpg";
import blog7 from "../assets/images/blog-7.jpg";
import blog8 from "../assets/images/blog-8.jpg";
import blog9 from "../assets/images/blog-9.jpg";
import blog10 from "../assets/images/blog-10.jpg";
import blog11 from "../assets/images/blog-11.jpg";
import blog12 from "../assets/images/blog-12.jpg";

const blogs = [
  {
    slug: "introduction-data-science",
    title: "Introduction to Data Science",
    image: blog1,
    date: "Jan 10, 2026",
    author: "Admin",
    category: "AI",
    content: `
		<p>Data Science is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Data Science?</h2>
		<p>Data Science combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "machine-learning",
    title: "Machine Learning Explained",
    image: blog2,
    date: "Jan 12, 2026",
    author: "Rahul",
    category: "ML",
    content: `
		<p>Machine Learning is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Machine Learning?</h2>
		<p>Machine Learning combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "deep-learning",
    title: "Deep Learning Fundamentals",
    image: blog3,
    date: "Jan 15, 2026",
    author: "Priya",
    category: "Deep Learning",
    content: `
		<p>Deep Learning Fundamentals is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Deep Learning Fundamentals?</h2>
		<p>Data Science combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "data-visualization",
    title: "Data Visualization Techniques",
    image: blog4,
    date: "Jan 22, 2026",
    author: "Ankit",
    category: "Visualization",
    content: `
		<p>Data Visualization Techniques is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Data Visualization Techniques?</h2>
		<p>Data Science combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "python-data-analysis",
    title: "Python for Data Analysis",
    image: blog5,
    date: "Jan 28, 2026",
    author: "Rahul",
    category: "Python Data",
    content: `
		<p>Python for Data Analysis is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Python Data Analysis?</h2>
		<p>Data Science combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "big-data",
    title: "Big Data Technologies",
    image: blog6,
    date: "Feb 02, 2026",
    author: "Megha",
    category: "Data Technologies",
    content: `
		<p>Data Technologies is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Big Data Technologies?</h2>
		<p>Data Science combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "ai-business",
    title: "AI in Business",
    image: blog7,
    date: "Feb 08, 2026",
    author: "Disha",
    category: "AI Business",
    content: `
		 <p>AI Business is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is AI Business?</h2>
		<p>AI Business combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "data-cleaning",
    title: "Data Cleaning Best Practices",
    image: blog8,
    date: "Feb 10, 2026",
    author: "Dinesh",
    category: "Data Cleaning",
    content: `
		 <p>Data Cleaning is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Data Cleaning?</h2>
		<p>Data Cleaning combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "predictive-analytics",
    title: "Predictive Analytics",
    image: blog9,
    date: "Feb 18, 2026",
    author: "Gopal",
    category: "Predictive",
    content: `
		<p>Predictive Analytics is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Predictive Analytics?</h2>
		<p>Predictive Analytics combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, 
		and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "nlp",
    title: "Natural Language Processing",
    image: blog10,
    date: "Feb 20, 2026",
    author: "Ganesh",
    category: "Deep Learning",
    content: `
		<p>Natural Language Processing is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Natural Language Processing?</h2>
		<p>Natural Language Processing combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations,	and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "career-guide",
    title: "Data Science Career Guide",
    image: blog11,
    date: "Mar 11, 2026",
    author: "Divya",
    category: "Visualization",
    content: `
		<p>Data Science Career Guide is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Data Science Career Guide?</h2>
		<p>Data Science Career Guide combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
  {
    slug: "ethics-ai",
    title: "Ethics in AI",
    image: blog12,
    date: "Mar 18, 2026",
    author: "Rajesh",
    category: "Ethics",
    content: `
		<p>Ethics in AI is one of the most powerful and in-demand fields in today’s digital world. It involves collecting, analyzing, and interpreting data to extract meaningful insights that help businesses make smarter decisions.</p>

		<h2>What is Ethics in AI?</h2>
		<p>Ethics in AI combines statistics, programming, and domain knowledge to analyze structured and unstructured data. It enables organizations to predict trends, improve operations, and gain a competitive advantage.</p>

		<h2>Key Components</h2>
		<ul><li>Data Collection &amp; Cleaning</li><li>Data Analysis &amp; Visualization</li><li>Machine Learning Models</li><li>Decision Making</li></ul>

		<h2>Why Data Science Matters</h2>
		<p>Businesses today rely heavily on data. With data science, companies can understand customer behavior, optimize marketing strategies, and increase efficiency.</p>

		<h2>Tools &amp; Technologies</h2>
		<p>Popular tools include Python, R, SQL, TensorFlow, and Power BI. These tools help process and visualize data effectively.</p>

		<h2>Conclusion</h2>
		<p>Data Science is shaping the future. Whether you’re a beginner or a professional, learning data science opens doors to endless opportunities.</p>
    `
  },
];

export default blogs;